import React, { useState } from 'react';
import CustomInput from "./customInput";
import CustomSelect from "./CustomSelect";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import configData from "../config.json";

export default function InputForm(props) {

    const folderPath = configData.IMAGE_URL + "event/";

    var test = [];
    for (var i = 0; i < 3; i++) {
        test.push(0);
    }


    const [modal, setModal] = useState(false);
    const toggle = () => setModal(!modal);

    const [selectedStyleNo, setSelectedStyleNo] = useState('');
    const [selectedSizingSystem, setSelectedSizingSystem] = useState('');
    const [sizes, setSizes] = useState([]);
    const [locations, setLocations] = useState([]);

    const [selectedSize, setSelectedSize] = useState('');
    const [selectedLocation, setSelectedLocation] = useState('');

    const [alertSelectFields, setAlertSelectFields] = useState(false);

    const updateSizesLocation = (styleNo) => {
        var sizes = props.items.find(i => i.styleNo === (styleNo ?? selectedStyleNo)).sizes;
        var locs = props.items.find(i => i.styleNo === (styleNo ?? selectedStyleNo)).locs;
        var sizingSystem = props.items.find(i => i.styleNo === (styleNo ?? selectedStyleNo)).sizingSystem;
        setSelectedSizingSystem(sizingSystem);

        var availableSizes =
            sizes
                .map(i => ({ name: i, value: i }));

        if (sizes.length === 1) {
            setSelectedSize(sizes[0]);
        }

        setSizes(availableSizes);

        var availableLocations =
            locs
                .map(i => {
                    var loc = props.locations.find(l => l.code === i);
                    return { name: loc.addressEn + ' / ' + loc.addressChi, value: loc.code }
                });

        if (locs.length === 1) {
            setSelectedLocation(locs[0]);
        }

        setLocations(availableLocations);
    };

    const selectStyle = (styleNo) => {
        setAlertSelectFields(false);
        setSelectedSize('');
        setSelectedLocation('');
        setSelectedStyleNo(styleNo);
        updateSizesLocation(styleNo);
        toggle();
    };

    const changeSize = (e) => {
        setSelectedSize(e.target.value);
    }


    const changeLocation = (e) => {
        setSelectedLocation(e.target.value);
    }

    const addItems = () => {
        if (selectedLocation !== "" && selectedSize !== "") {
            props.updateItems(selectedStyleNo, selectedSize, selectedLocation);
            toggle();
        } else {
            setAlertSelectFields(true);
        }
    }


    const removeItems = () => {
        props.removeItems(selectedStyleNo);
        toggle();
    }

    const checkItemAdded = (styleNo) => {
        if (props.form.items.find(i => i.styleNo === styleNo)) {
            return true;
        } else {
            return false;
        }
    }

    const checkAnyItemAdded = (styleNo) => {
        if (props.form.items.length === 0) {
            return false;
        }
        if (props.form.items.find(i => i.styleNo === styleNo)) {
            return false;
        } else {
            return true;
        }
    }

    return (
        <div>
            <Modal isOpen={modal} toggle={toggle}>
                <ModalHeader toggle={toggle} />
                <ModalBody>
                    <img alt={selectedStyleNo} style={{ 'width': '100%' }} src={folderPath + props.eventCode + "/" + selectedStyleNo + "_image.jpg"} />
                    <CustomSelect
                        name={"Size / 尺碼 (" + selectedSizingSystem + ")"}
                        options={sizes}
                        selectedValue={selectedSize}
                        onChange={ changeSize } />
                    <CustomSelect
                        name="Pick-up Location / 取貨店鋪"
                        options={locations}
                        selectedValue={selectedLocation}
                        onChange={changeLocation} />
                    <span className={alertSelectFields ? 'text-danger' : 'd-none'}>Please select size and pickup location / 請選擇尺碼及取貨店鋪</span>
                </ModalBody>
                <ModalFooter className="d-flex justify-content-around">
                    <Button style={{ 'width': '40%' }} color="success" size="lg" onClick={addItems}>&#10003;</Button>{' '}
                    <Button style={{ 'width': '40%' }} color="danger" size="lg" onClick={removeItems}>&#10007;</Button>
                </ModalFooter>
            </Modal>
            <div className="border-bottom pb-3 mb-3">
            <h5>Register / 登記</h5>
            <p className="text-right text-danger">
                * Compulsory Field<br />&nbsp; 必須填寫
            </p>
            

            <CustomInput
                name1="Full name in Chinese (must be same as HKID/Passport)"
                name2="中文姓名 (需與身分證/護照上的姓名完全相同)"
                desc1='*If you do not have a Chinese name, please write " NA"'
                desc2='如沒有中文姓名，請以"NA"代替 *'
                disabled={false}
                value={props.form.name}
                onChange={(e) => props.setForm({ ...props.form, 'name': e.target.value })}
                pattern="^[^<>&'\x22]{1,64}$"
                errMsg="Please input your full name in 64 characters" />


            <CustomInput
                name1="Full name in English (must be same as HKID/Passport)"
                name2="英文姓名 (需與身分證/護照上的姓名完全相同)"
                disabled={false}
                value={props.form.enName}
                onChange={(e) => props.setForm({ ...props.form, 'enName': e.target.value })}
                pattern="^[^<>&'\x22]{1,64}$"
                errMsg="Please input your full name in 64 characters" />

            <CustomInput
                name1="HKID Card / Passport No. (First 5 digits e.g. A1234)"
                name2="身份證明文件號碼 (頭5位字元包括英文字母)"
                disabled={false}
                value={props.form.hkid}
                onChange={(e) => props.setForm({ ...props.form, 'hkid': e.target.value })}
                pattern="^[^<>&'\x22]{5}$"
                errMsg="Please enter valid card no." />

            <CustomInput
                name1="Hong Kong Mobile Phone No."
                name2="香港手提電話號碼"
                disabled={false}
                value={props.form.phone}
                onChange={(e) => props.setForm({ ...props.form, 'phone': e.target.value })}
                pattern="^\d{8}$"
                errMsg="Please enter valid phone number" />

            <CustomInput
                name1="Email Address"
                name2="電郵地址"
                disabled={false}
                value={props.form.email}
                onChange={(e) => props.setForm({ ...props.form, 'email': e.target.value })}
				pattern="^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])+\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$$"
                type="email" />

				{
					props.socialMedia && <CustomInput
					name1="Social Media Account"
					name2="社交平台帳號"
					disabled={false}
					value={props.form.socialMedia}
					onChange={(e) => props.setForm({ ...props.form, 'socialMedia': e.target.value })}
					pattern="^[^<>&'\x22]{1,64}$" />
				}
            </div>
            <div>
                <p className="font-weight-bold text-danger">Please select, more than one product model can be selected (if applicable) <br/> 請選擇，可選擇多於一個產品型號 (如適用) *</p>
                <div className="wrapper">
                    {
                        props.items && props.items.map((item, index) => (
                            <div key={'items_' + index} onClick={() => selectStyle(item.styleNo)}>
                                <img className={(checkItemAdded(item.styleNo) ? "border border-success border3" : "")} alt={item.styleNo} style={{ 'width': '100%' }} src={folderPath + props.eventCode + "/" + item.styleNo + "_thumbnails.jpg"} />
                                { checkAnyItemAdded(item.styleNo) && <div className='grey-background'></div>}
                            </div>
                        ))
                    }
                </div>
            </div>

        </div>
    );
}
